import { Col, Form, Input, Row, Table } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import { defaultFormItemLayout } from 'modules/FormItems'
import { strVal } from 'modules/Utils'
import React, { useEffect, useState } from 'react'
import { isEmpty } from 'rxjs/operators'
import Members from '../../../../api/Members'

const Search = Input.Search

const api = new Members()

function Existing({ setMember }) {
  const { data: individuals, fetching: individualsFetching, fetch: individualsFetch } = useFetch({
    url: `/members/list/individual`,
  })

  const { data: organisations, fetching: organisationsFetching, fetch: organisationsFetch } = useFetch({
    url: `/members/list/organisation`,
  })

  const [list, setList] = useState([])

  useEffect(() => {
    console.log('in')
    setList([...(individuals || []), ...(organisations || [])])
  }, [individualsFetching, organisationsFetching])

  const fetching = individualsFetching || organisationsFetching
  const fetch = () => {
    individualsFetch()
    organisationsFetch()
  }

  const columns = [
    {
      title: 'Full Name',
      dataIndex: 'fn',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      render: (text, record, index) => strVal(record, 'email.label'),
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      render: (text, record, index) => strVal(record, 'phone.label'),
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      render: (text, record, index) => strVal(record, 'mobile.label'),
    },
  ]

  const onSearch = (e) => {
    const data = [...individuals, ...organisations].filter((row) =>
      strVal(row, 'fn').toUpperCase().includes(e.target.value.toUpperCase())
    )

    setList(data)
  }

  const onRowClick = (record) => {
    setMember(record)
  }

  const rowSelection = {
    onSelect: (record) => {
      onRowClick(record)
    },
    type: 'radio',
  }
  return (
    <div style={{ marginTop: 20 }}>
      <Form layout="horizontal">
        <Row>
          <Col span={24}>
            <Form.Item {...defaultFormItemLayout} label="Name" hasFeedback validateStatus={fetching && 'validating'}>
              <Search placeholder="Search for a Contact" onChange={onSearch} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row style={{ textAlign: 'left' }}>
        <Table
          loading={fetching}
          rowKey={'_key'}
          //pagination={{pageSize: 5}}
          showHeader={true}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={list}
        />
      </Row>
    </div>
  )
}

export default Existing
